export enum LoadingAction {
  None = '',
  Loading = 'Loading',
  Saving = 'Saving',
  Uploading = 'Uploading',
  Sending = 'Sending',
  Updating = 'Updating',
  Downloading = 'Downloading',
  Copying = 'Copying',
  Cutting = 'Cutting',
  Pasting = 'Pasting'
}
